module.exports = __webpack_public_path__ + "fonts/NunitoSans-Regular.4c8f447.ttf";